import { Engagement, Worksite } from "@wingspanhq/wingspan-api-sdk";
import groupBy from "lodash/groupBy";

import { WorksiteTableItem } from "../components/TableWorksites/TableWorksites";

/**
 * Joins each work site with the engagements pointing at it.
 *
 * `listEngagements` has no `worksiteId` filter, so the association is derived
 * here from the whole (small, account-level) engagement-type list rather than
 * per-row requests.
 */
export const selectorWorksiteTableItems = ({
  worksites,
  engagements
}: {
  worksites: Worksite[];
  engagements: Engagement[];
}): WorksiteTableItem[] => {
  const engagementsByWorksiteId = groupBy(
    engagements.filter(engagement => !!engagement.worksiteId),
    engagement => engagement.worksiteId
  );

  return worksites.map(worksite => ({
    worksite,
    engagementNames: (worksite.id
      ? (engagementsByWorksiteId[worksite.id] ?? [])
      : []
    ).map(engagement => engagement.name ?? "")
  }));
};
